import React from "react";
import { connect } from "react-redux";
import { Content, Container } from "../../pages/Template";
import CreateDocLink from "./CreateDocLink";
import SearchDocs from "./SearchDocs";
import List from "./List";
import { isMobile, setWindowTitle } from "../../helpers";
import { AppState } from "../../store";

const mapStateToProps = ({ docs }: AppState) => ({
    // @ts-ignore
    showFilter: docs && docs.size > 5,
});

type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps;
type State = {
    filter: string;
};

class DocsPage extends React.Component<Props, State> {
    static paths = ["/app/docs"];
    static requiresAuth = true;

    constructor(props: Props) {
        super(props);
        this.state = {
            filter: "",
        };
    }

    onFilterChange = (_k: string, filter: string) => this.setState({ filter });

    componentDidMount() {
        setWindowTitle("دستاویزات");
    }

    render() {
        const { showFilter } = this.props;
        const { filter } = this.state;

        return (
            <Content isLandingPage={isMobile()}>
                <Container>
                    <CreateDocLink />
                    {showFilter && (
                        <SearchDocs
                            filter={filter}
                            onChange={this.onFilterChange}
                        />
                    )}
                    <List filter={filter} />
                </Container>
            </Content>
        );
    }
}

export default connect(mapStateToProps)(DocsPage);
